type MainLabelsType = Array<{
  __typename?: 'Label';
  id: string;
  title?: string;
  description?: string | null | undefined;
  image?: string;
}>;

export const mainLabels: MainLabelsType = [
  {
    id: '1',
    title: 'Мы не просто сервис',
    description: `Объединяя ведущие лабораторные сети, мы&nbsp;даем вам выбор, в&nbsp;какую лабораторию отвезем ваш биоматериал.`,
    image: '/images/about/service.png',
  },
  {
    id: '3',
    title: 'Лучшие медсестры',
    description: `Вне зависимости от&nbsp;выбора <nobr>какой-либо</nobr> лаборатории к&nbsp;вам приедет первоклассная
        медицинская сестра, задача которой&nbsp;&mdash; взятие биоматериала с&nbsp;максимальным комфортом.`,
    image: '/images/about/sister.png',
  },
  {
    id: '5',
    title: 'Собственная школа медсестер',
    description: `Высокопрофессиональные медсестры обучаются в&nbsp;нашей собственной школе, где после пристального отбора проходят дополнительное обучение.`,
    image: '/images/about/school.png',
  },
];
